import axios from "axios";
import { API_URL } from "./config";

export const apiCall = async (url, method, data, formevent) => {
    if (formevent !== null) {
        const form = formevent?.currentTarget;
        formevent?.preventDefault();
        formevent?.stopPropagation();
        if (form?.checkValidity() === false) {
            try { return { "code": 200, "data": { "status": false, "message": "Form not validate", "error": [] } } }
            catch (error) { }
        } try {
            const response_1 = await axios({
                url: url,
                method: method,
                data: data,
            });
            return { "code": response_1.status, "data": response_1.data };
        } catch (error) {
            return { "code": 1, "data": error.response.data };
        }
    }
};

export const apiCallNoForm = async (url, method, data) => {
    try {
        const response_1 = await axios({
            url: url,
            method: method,
            data: data,
        });
        return { "code": response_1.status, "data": response_1.data };
    } catch (error) {
        return { "code": 1, "data": error.response.data };
    }
};


export const multipartApiCall = (url, method, data) => {
    return axios({
        method: method,
        url: url,
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
        .then((response) => {
            return { "code": response.status, "data": response.data };
        })
        .catch((error) => {
            return { "code": 0, "data": error.response.data };
        });
};


export const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("camera_fitting_data");
    localStorage.removeItem("firstfilename");
    localStorage.removeItem("secondfilename");
    localStorage.removeItem("attachment");
    localStorage.removeItem("currenttab");
    localStorage.removeItem("link");
    localStorage.removeItem("filmswingvalidate");
    localStorage.removeItem("irontestValidate");
    localStorage.removeItem("balldatavalidate");
    window.location.href = "/";
}


export const setUser = (data) => {
    return localStorage.setItem("user", data);
}

export const isAuthenticated = () => {
    const user = getCurrentUser();
    if (user) {
        return true;
    }
    return false;
}

export const getCurrentUser = () => {
    console.log("getCurrentUser", JSON.parse(localStorage.getItem("user")));
    return JSON.parse(localStorage.getItem("user"));
}



export const addUser = (data, e) => {
    return apiCall(`${API_URL}user/addUser`, "POST", data, e);
}

export const getUserById = (data, event) => {
    return apiCall(`${API_URL}user/getUserById`, "POST", data, event);
}

export const updateUser = (data, event) => {
    return apiCall(`${API_URL}user/updateUser`, "POST", data, event);
}

export const updateUserremotefitting = (data, event) => {
    return apiCall(`${API_URL}user/updateUserremotefitting`, "POST", data, event);
}

export const getUserByIds = (data) => {
    return apiCall(`${API_URL}user/addUser`, "POST", data, null);
}

export const activeuser = (data) => {
    return apiCall(`${API_URL}user/activeuser`, "POST", data);
}

export const getUserByKeyword = (data, event) => {
    let keyword = data.params.keyword;
    return apiCall(`${API_URL}user/getUserByKeyword/?keyword=${keyword}`, "GET", data, event);
}

export const getreferralByKeyword = (data, event) => {
    let keyword = data.params.keyword;
    return apiCall(`${API_URL}user/getreferralByKeyword/?keyword=${keyword}`, "GET", data, event);
}

export const getErrorByField = (errors, field) => {
    return errors.filter(function (item) {
        if (item.field === field) { return { "field": item.field, "message": item.message } }
    });
}



export const deletedabasedataApi = () => {
    return apiCall(`${API_URL}user/deletedabasedata`, "GET",);
}


